import { fromIsoDay, sameDay, startOfDay } from "components/crm/ui/crmTime";

// Everything here runs in the device's local time.
const MOMENT_STEP_MINUTES = 5;

export const clock = (date) =>
  `${date.getHours()}:${String(date.getMinutes()).padStart(2, "0")}`;

export const atClock = (day, [hours, minutes]) => {
  const at = new Date(day);
  at.setHours(hours, minutes, 0, 0);
  return at;
};

// Next calendar day, skipping Sunday only.
export const nextWorkingDay = (now) => {
  const day = startOfDay(now);
  day.setDate(day.getDate() + 1);
  if (day.getDay() === 0) day.setDate(day.getDate() + 1);
  return day;
};

export const callMoments = (now) => {
  const step = MOMENT_STEP_MINUTES * 60000;
  const hourAt = new Date(now);
  hourAt.setSeconds(0, 0);
  hourAt.setMinutes(hourAt.getMinutes() + 60);
  const hour = new Date(Math.ceil(hourAt.getTime() / step) * step);

  const moments = [{ id: "hour", at: hour }];
  if (now.getHours() < 14) {
    moments.push({ id: "afternoon", at: atClock(now, [15, 0]) });
  }
  const tomorrow = nextWorkingDay(now);
  const nextDay = new Date(startOfDay(now));
  nextDay.setDate(nextDay.getDate() + 1);
  moments.push({
    id: "tomorrow",
    at: atClock(tomorrow, [9, 0]),
    nextDay: sameDay(tomorrow, nextDay),
  });
  return moments;
};

export const defaultRetry = (now) => (now.getHours() < 14 ? "afternoon" : "tomorrow");

export const parseClock = (text) => {
  const match = /^(\d{1,2})\s*[:hH.]?\s*(\d{2})?$/.exec(String(text ?? "").trim());
  if (!match) return null;
  const hours = Number(match[1]);
  const minutes = match[2] === undefined ? 0 : Number(match[2]);
  return hours > 23 || minutes > 59 ? null : [hours, minutes];
};

export const resolveWhen = ({ choice, day, time }, moments, now) => {
  if (choice !== "other") {
    return moments.find((moment) => moment.id === choice)?.at ?? null;
  }
  const clockValue = parseClock(time);
  if (!day || !clockValue) return null;
  const at = atClock(fromIsoDay(day), clockValue);
  return at > now ? at : null;
};

export const longDay = (date, locale = "fr") =>
  new Intl.DateTimeFormat(locale, {
    weekday: "long",
    day: "numeric",
    month: "long",
  }).format(date);

export const weekdayName = (date, locale = "fr") =>
  new Intl.DateTimeFormat(locale, { weekday: "long" }).format(date);

export const whenKey = (at, now) => {
  if (sameDay(at, now)) return "today";
  const next = startOfDay(now);
  next.setDate(next.getDate() + 1);
  return sameDay(at, next) ? "tomorrowAt" : "onDay";
};
